module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-modal__employment text-dark"
  }, [_c('button', {
    on: {
      "click": _vm.openIsModal
    }
  }, [_c('span', {
    staticClass: "icon-pencil"
  })]), _vm._v(" "), (_vm.isModal) ? _c('DModal', {
    staticClass: "d-modal__employment-modal",
    attrs: {
      "showClose": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Ansættelser for " + _vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.closeIsModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body"
  }, [(!_vm.isAllDoneLoading) ? _c('div', {
    staticClass: "is-loading-container"
  }, [_c('Loader', {
    attrs: {
      "isLoaderModal": true
    }
  })], 1) : [(_vm.userEmployments.length === 0) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen ansættelser oprettet")]) : _vm._e(), _vm._v(" "), (_vm.userEmployments.length > 0) ? _c('div', {
    staticClass: "d-modal__employment__employments"
  }, [_c('ul', [_c('li', {
    staticClass: "d-modal__employment__employments__header"
  }, [_c('div', [_vm._v("Ansættelse")]), _vm._v(" "), _c('div', [_vm._v("CPR NUMMER + EKSTRACIFFER")])]), _vm._v(" "), _vm._l((_vm.userEmploymentsWithTitle), function(userEmployment) {
    return _c('li', {
      key: userEmployment.id,
      staticClass: "d-modal__employment__employments__employment"
    }, [_c('div', {
      staticClass: "d-modal__employment__employments__employment__container"
    }, [_c('div', [_vm._v(_vm._s(userEmployment.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(userEmployment.employment_number))])]), _vm._v(" "), _c('span', {
      staticClass: "icon__bg-circle icon__bg-circle--danger",
      on: {
        "click": function($event) {
          return _vm.setDeleteEmployment(userEmployment)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])])
  }), _vm._v(" "), (_vm.userDeletedEmployments.length > 0) ? _c('li', {
    staticClass: "text-blue text-link marg-1-bottom",
    on: {
      "click": function($event) {
        _vm.isShowArchived = !_vm.isShowArchived
      }
    }
  }, [(!_vm.isShowArchived) ? _c('span', [_vm._v("Se")]) : _vm._e(), (_vm.isShowArchived) ? _c('span', [_vm._v("Skjul")]) : _vm._e(), _vm._v(" tidligere ansættelser\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.deletedUserEmploymentsWithTitle), function(userEmployment) {
    return (_vm.isShowArchived) ? _c('li', {
      key: userEmployment.id,
      staticClass: "d-modal__employment__employments__employment d-modal__employment__employments__employment--deleted"
    }, [_c('div', {
      staticClass: "d-modal__employment__employments__employment__container"
    }, [_c('div', [_vm._v(_vm._s(userEmployment.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(userEmployment.employment_number))])])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [(!_vm.isCreateForm) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.setIsCreateForm(true)
      }
    }
  }, [_vm._v("Tilføj ansættelse")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scaleIn",
      "mode": "out-in"
    }
  }, [(_vm.isCreateForm) ? _c('div', {
    staticClass: "d-modal__employment__form"
  }, [_c('h4', [_vm._v("Tilføj ansættelse")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-flex"
  }, [_c('div', {
    staticClass: "input-group flex-1 input-group__select"
  }, [_c('label', [_vm._v("Ansættelsestype")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createFormEmploymentTypeId),
      expression: "createFormEmploymentTypeId"
    }],
    class: {
      'input--error': _vm.formErrors['type']
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.createFormEmploymentTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.removeErrors('type')
      }]
    }
  }, _vm._l((_vm.employmentTypesActive), function(employmentType) {
    return _c('option', {
      domProps: {
        "value": employmentType.id
      }
    }, [_vm._v("\n                      " + _vm._s(employmentType.title) + "\n                    ")])
  }), 0), _vm._v(" "), (_vm.formErrors['type']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['type']))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group flex-1"
  }, [_c('label', [_vm._v("CPR nummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.createFormCPR),
      expression: "createFormCPR",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      'input--error': _vm.formErrors['cpr']
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.createFormCPR)
    },
    on: {
      "keyup": function($event) {
        return _vm.removeErrors('cpr')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.createFormCPR = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.formErrors['cpr']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['cpr']))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group flex-1 extra-ciffer-input"
  }, [_c('label', [_vm._v("Ekstraciffer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.createFormExtraCiffer),
      expression: "createFormExtraCiffer",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      'input--error': _vm.formErrors['ciffer']
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.createFormExtraCiffer)
    },
    on: {
      "keyup": function($event) {
        return _vm.removeErrors('ciffer')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.createFormExtraCiffer = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.formErrors['ciffer']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['ciffer']))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "marg-10-right",
    on: {
      "click": _vm.closeIsCreateForm
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.createEmployment
    }
  }, [_vm._v("Tilføj ansættelse")])])]) : _vm._e()])]], 2)])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEmployment) ? _c('DModal', {
    attrs: {
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "d-modal__delete-employment",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Vil du slette ansættelsen?")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        _vm.theDeleteEmployment = null
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body"
  }, [_c('p', [_vm._v("Vil du slette "), _c('b', [_c('i', [_vm._v(_vm._s(_vm.theDeleteEmployment.title))])]), _vm._v(" for " + _vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "marg-10-right",
    on: {
      "click": function($event) {
        _vm.theDeleteEmployment = null
      }
    }
  }, [_vm._v("Nej")]), _vm._v(" "), _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.deleteEmployment
    }
  }, [_vm._v("Ja, slet ansættelsen")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
    staticClass: "bg-overlay"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b64843ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Employment.vue
// module id = 1727
// module chunks = 1